import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  resultScreen: {
    width: "100%",
    height: "100%",
    position: "fixed",
    zIndex: 999,
    background: theme.colors.background1,
    top: 0,
    boxSizing: "border-box",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  content: {
    width: "100%",
    position: "relative",
    "@media (orientation: landscape)": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing.space16,
      overflowY: "scroll",
      "-ms-overflow-style": "none" /* IE and Edge */,
      scrollbarWidth: "none" /* Firefox */,
      /* Hide scrollbar for Chrome, Safari and Opera */
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  lbRank: {
    background: "#111622",
    color: "#FFF",
    padding: "6px 16px",
    borderRadius: 24,
    border: "1.5px solid rgba(255, 255, 255, 0.20)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    fontSize: 14,
    width: "fit-content !important",
    height: 26,
    transition: "all 0.3s ease-in-out",
  },
  rank: {
    width: "100%",
    display: "flex",
    justifyContent: "end",
  },
}));
